






















import Vue, { PropType } from 'vue';
// import GLink from '@/components/Atoms/GLink.vue';

export default Vue.extend({
  name: 'GRoundedArrowButton',
  // components: {
  //   GLink,
  // },
  props: {
    to: {
      type: String as PropType<string>,
      default: '',
    },
    blank: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    bold: Boolean as PropType<boolean>,
    large: Boolean as PropType<boolean>,
  },
  methods: {
    onClick(): void {
      this.$emit('click');
    },
  },
});
